
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infobip-alternative",
      function () {
        return require("private-next-pages/infobip-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infobip-alternative"])
      });
    }
  